import { fetchService } from "./fetchService";
import * as API_PATHS from "utility/api-paths";

interface WandbOnboardingRequest {
  request_number: string;
  status: string;
  env: string;
  user_email: string;
  message: string;
}

export const updateWandbProvisioningService = async (
  cloudServiceData: WandbOnboardingRequest
): Promise<string> => {
  try {
    const response = await fetchService<string>(
      API_PATHS.WANDB_ONBOARDING_STATUS_UPDATE_REQUEST,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: cloudServiceData,
      }
    );
    return response;
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : "An unknown error occurred."
    );
  }
};
